import { useTranslation } from "react-i18next";

export default function SolutionSection() {
  const { t } = useTranslation();

  const steps = [
    {
      number: "1",
      title: t("solution.step1_title"),
      desc: t("solution.step1_desc"),
      icon: "ri-smartphone-line",
      img: "https://readdy.ai/api/search-image?query=Cameroonian%20person%20holding%20smartphone%20browsing%20food%20delivery%20app%20screen%20showing%20local%20dishes%20menu%20warm%20indoor%20lighting%20cozy%20home%20setting%20authentic%20modern%20African%20lifestyle%20editorial%20photography%20natural%20colors%20clean%20composition&width=600&height=500&seq=solution-order-v2&orientation=portrait"
    },
    {
      number: "2",
      title: t("solution.step2_title"),
      desc: t("solution.step2_desc"),
      icon: "ri-motorbike-line",
      img: "https://readdy.ai/api/search-image?query=Cameroonian%20motorcycle%20delivery%20rider%20wearing%20helmet%20smiling%20confident%20holding%20smartphone%20on%20busy%20Douala%20street%20colorful%20background%20warm%20golden%20hour%20lighting%20authentic%20urban%20scene%20editorial%20photography%20professional%20composition&width=600&height=500&seq=solution-rider-v2&orientation=portrait"
    },
    {
      number: "3",
      title: t("solution.step3_title"),
      desc: t("solution.step3_desc"),
      icon: "ri-smartphone-line",
      img: "https://readdy.ai/api/search-image?query=Mobile%20Money%20transaction%20on%20smartphone%20screen%20MTN%20Mobile%20Money%20Orange%20Money%20interface%20Cameroon%20digital%20payment%20warm%20lighting%20clean%20modern%20setting%20hands%20holding%20phone%20editorial%20product%20photography&width=600&height=500&seq=solution-payment-v2&orientation=portrait"
    },
    {
      number: "4",
      title: t("solution.step4_title"),
      desc: t("solution.step4_desc"),
      icon: "ri-restaurant-2-line",
      img: "https://readdy.ai/api/search-image?query=Hot%20freshly%20delivered%20Cameroonian%20meal%20in%20takeaway%20container%20ndole%20poulet%20DG%20fish%20grilled%20plantains%20arranged%20beautifully%20on%20table%20warm%20inviting%20lighting%20appetizing%20presentation%20editorial%20food%20photography&width=600&height=500&seq=solution-delivery-v2&orientation=portrait"
    },
  ];

  return (
    <section className="relative w-full py-20 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-800 text-xs font-semibold uppercase tracking-wider mb-5">
            Comment ca marche
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-5">
            {t("solution.title")}
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-xl mx-auto">
            {t("solution.subtitle")}
          </p>
          <div className="w-20 h-1 bg-primary-500 rounded-full mx-auto mt-5"></div>
        </div>

        {/* Steps - Horizontal timeline */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {steps.map((step, index) => (
            <div key={index} className="group relative">
              {/* Step number badge */}
              <div className="absolute -top-3 -left-3 z-20 w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center shadow-lg">
                <span className="text-sm font-bold text-background-50">{step.number}</span>
              </div>

              <div className="bg-background-50 rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-500 hover:shadow-lg h-full">
                {/* Image */}
                <div className="h-48 overflow-hidden">
                  <img
                    src={step.img}
                    alt={step.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                {/* Content */}
                <div className="p-5 md:p-6">
                  <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center mb-3">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className={`${step.icon} text-primary-600`}></i>
                    </div>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                    {step.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {step.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}